import script from "./BrushMapHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapHeader.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapHeader.vue?vue&type=style&index=0&id=2c777a37&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c777a37"]])

export default __exports__